// extracted by mini-css-extract-plugin
export var bounce = "_ln-1";
export var generatingText = "_ln-6";
export var lightning = "_ln-4";
export var popup = "_ln-5";
export var progressBar = "_ln-7";
export var progressFill = "_ln-8";
export var progressShimmer = "_ln-9";
export var progressText = "_ln-a";
export var shimmer = "_ln-3";
export var uploadIcon = "_ln-0";
export var uploadingText = "_ln-2";